<template>
  <div id="applicationManagement">
    <div class="container" style="text-align: left">
      <K2Row style="margin: 20px 0px">
        <label style="width: 100%; font-size: 24px">ONLINE WITHDRAWAL FORM FOR STAFF</label>
        <router-link :to="{ name: 'WithdrawalList' }">
          <K2Button>Back</K2Button>
        </router-link>
      </K2Row>
      <div class="row common-row-div-margin" v-if="listCount > 0">
        <div class="enrolment-manage-container w-100">
          <div class="enrol-manage-content-container">
            <div class="enrol-manage-child-container">
              <div style="display: flex; justify-content: space-between" class="mb-2">
                <label v-if="enrolStatus === 'Approved' || enrolStatus === 'Verified'">
                  <span style="padding: 5px 15px; border-radius: 6px; background: green; color: #ffffff">{{ enrolStatus }}</span>
                </label>
                <label v-else>
                  <span style="padding: 5px 15px; border-radius: 6px; background: red; color: #ffffff">{{ enrolStatus }}</span>
                </label>
                <div>
                  <a
                    v-if="enrolStatus === 'Approved' || enrolStatus === 'Verified'"
                    :href="`${apiHost}/controller/Api.asmx/ExportWithdrawalFormAsPdf?id=${withdrawalFormID}`"
                    class="el-button el-button--secondary"
                    target="_blank"
                    >PRINT (PDF)</a
                  >
                  <a
                    v-if="enrolStatus !== 'Pending' && enrolStatus !== 'Verified'"
                    @click="sendNotification()"
                    class="el-button el-button--secondary"
                    target="_blank"
                    >SEND NOTIFICATION</a
                  >
                </div>
              </div>

              <section>
                <WithdrawalFormLogo :current-school="currentSchool" :isInternationalSchool="isInternationalSchool" />
                <!--student information: start-->
                <WdfStudentInformation
                  :state="state"
                  @change="state.StudentPass = $event"
                  :isInternationalSchool="isInternationalSchool"
                  :readonly="!canEdit"
                />
                <!--student information: end-->

                <!--stud Withdraw Form: start-->

                <div style="margin-bottom: 20px">
                  <label class="common-label-title">Student Withdraw Form</label>
                </div>
                <div>
                  <OnlineStudentWithdrawForm
                    :isHideButton="true"
                    :passData="state"
                    :readonly="!canEdit"
                    :withdrawalDateRemarks="'(last day of attendance in school)'"
                    :withdrawReasonList="withdrawReasonList"
                    :disableDate="!enableWithdrawalDate"
                    @school="handleInputChange('School', $event)"
                    @schoolText="handleInputChange('SchoolDetails', $event)"
                    @SchoolType="handleInputChange('SchoolType', $event)"
                    @reason1Text="handleInputChange('Reason1Text', $event)"
                    @reason1="handleInputChange('Reason1', $event)"
                    @CountryName="handleInputChange('CountryName', $event)"
                    @Improvement="handleInputChange('Improvement', $event)"
                    @date="handleInputChange('Date', $event)"
                    @main-reason="handleInputChange('MainReason', $event)"
                  />
                </div>
                <div :class="{ 'form-group--error': $v.state.MainReason.$error }">
                  <div class="error requiredFieldsMsg" v-if="!$v.state.MainReason.required" style="margin-bottom: 10px">
                    <el-alert :title="getValidationMessageFromKey('MainReason')" type="error"></el-alert>
                  </div>
                </div>
                <div :class="{ 'form-group--error': $v.state.CountryName.$error }">
                  <div class="error requiredFieldsMsg" v-if="!$v.state.CountryName.required" style="margin-bottom: 10px">
                    <el-alert :title="getValidationMessageFromKey('CountryName')" type="error"></el-alert>
                  </div>
                </div>
                <div :class="{ 'form-group--error': $v.state.SchoolType.$error }">
                  <div class="error requiredFieldsMsg" v-if="!$v.state.SchoolType.required" style="margin-bottom: 10px">
                    <el-alert :title="getValidationMessageFromKey('SchoolType')" type="error"></el-alert>
                  </div>
                </div>
                <div :class="{ 'form-group--error': $v.state.School.$error }">
                  <div class="error requiredFieldsMsg" v-if="!$v.state.School.required" style="margin-bottom: 10px">
                    <el-alert :title="getValidationMessageFromKey('School')" type="error"></el-alert>
                  </div>
                </div>
                <div :class="{ 'form-group--error': $v.state.SchoolDetails.$error }">
                  <div class="error requiredFieldsMsg" v-if="!$v.state.SchoolDetails.required" style="margin-bottom: 10px">
                    <el-alert :title="getValidationMessageFromKey('SchoolDetails')" type="error"></el-alert>
                  </div>
                </div>
                <div :class="{ 'form-group--error': $v.state.Reason1.$error }">
                  <div class="error requiredFieldsMsg" v-if="!$v.state.Reason1.required" style="margin-bottom: 10px">
                    <el-alert :title="getValidationMessageFromKey('Reason1')" type="error"></el-alert>
                  </div>
                </div>
                <div :class="{ 'form-group--error': $v.state.Reason1Text.$error }">
                  <div class="error requiredFieldsMsg" v-if="!$v.state.Reason1Text.required" style="margin-bottom: 10px">
                    <el-alert :title="getValidationMessageFromKey('Reason1Text')" type="error"></el-alert>
                  </div>
                </div>
                <div :class="{ 'form-group--error': $v.state.Improvement.$error }">
                  <div class="error requiredFieldsMsg" v-if="!$v.state.Improvement.required" style="margin-bottom: 10px">
                    <el-alert :title="getValidationMessageFromKey('Improvement')" type="error"></el-alert>
                  </div>
                </div>
                <!--stud Withdraw Form: end-->

                <!--stud pass Information: start-->
                <WdfStudentPassInformation :isInternationalSchool="isInternationalSchool" />
                <!--stud pass Information: end-->

                <!--bank account: start-->
                <div style="margin-bottom: 20px" class="mt-5">
                  <label class="common-label-title">Bank Account Details </label>
                </div>
                <div class="mb-3" style="display: grid; grid-template-columns: 1fr 1fr; row-gap: 1.5rem; column-gap: 3rem">
                  <ApfBasicInput label="Name of Account Holder">
                    <input class="form-control" type="text" v-model="state.BankAccountHolder" :readonly="!canEdit" />
                  </ApfBasicInput>
                  <ApfBasicInput label="Name of Bank">
                    <input class="form-control" type="text" v-model="state.BankName" :readonly="!canEdit" />
                  </ApfBasicInput>
                  <ApfBasicInput label="Swift Code">
                    <input class="form-control" type="text" v-model="state.BankCode" :readonly="!canEdit" />
                  </ApfBasicInput>
                  <ApfBasicInput label="Account Number">
                    <input class="form-control" type="text" v-model="state.BankAccount" :readonly="!canEdit" />
                  </ApfBasicInput>
                  <ApfBasicInput label="Email Address">
                    <input class="form-control" type="text" v-model="state.Email" :readonly="!canEdit" />
                  </ApfBasicInput>
                  <ApfBasicInput label="Contact Number">
                    <input class="form-control" type="text" v-model="state.Contact" :readonly="!canEdit" />
                  </ApfBasicInput>

                  <!--<ApfBasicInput name="accountHolderName" label="Name of Account Holder" :validator="$v">-->
                  <!--<input class="form-control" type="text" v-model="accountHolderName"/>-->
                  <!--</ApfBasicInput>-->
                </div>
                <p v-if="isInternationalSchool">By signing below, I certify that the above information is true.</p>
                <p v-else>
                  *If the deposit was paid using a Child Development Account (CDA), any balance that is refundable from the deposit will be credited back into
                  the relevant CDA. <br /><br />By signing below, I certify that the above information is true.
                </p>
                <div style="display: grid; grid-template-columns: 1fr 1fr; row-gap: 1.5rem; column-gap: 3rem">
                  <ApfBasicInput label="Name of Parent" name="parentName" :validator="$v">
                    <input class="form-control" type="text" v-model="state.ParentName" :readonly="!canEdit" />
                  </ApfBasicInput>

                  <ApfBasicInput name="siSignature" label="Signature" :validator="$v">
                    <div class="signature-pad">
                      <img v-if="state.ParentSignature" :src="state.ParentSignature" type="file" class="imgParentSignature" />
                    </div>
                  </ApfBasicInput>
                </div>

                <!--bank account: end-->
                <hr />
              </section>
              <section style="margin-bottom: 10px; display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 1rem">
                <h5 class="py-1" style="margin: 10px 0 20px; grid-column: 1/-1">For Official Use Only</h5>
                <div>
                  <label>Exception Request: </label>
                  <select class="form-control" v-model="state.ExceptionRequest" :disabled="!canEdit">
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                <div v-if="state.ExceptionRequest === 'yes'">
                  <label>Exception Request: </label>
                  <K2Upload @setExceptionRequestDocs="setExceptionRequestDocs" :ExceptionRequestDocs="state.ExceptionRequestDocs" />
                </div>
                <div :class="{ 'form-group--error': $v.state.isNotice.$error }">
                  <label>Sufficient Notice Given: </label>
                  <select class="form-control" v-model="state.isNotice" :disabled="!canEdit">
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>

                  <div class="error requiredFieldsMsg" v-if="!$v.state.isNotice.required" style="margin-bottom: 10px">
                    <el-alert :title="getValidationMessageFromKey('isNotice')" type="error"></el-alert>
                  </div>
                </div>
                <div v-if="state.isNotice === 'no'">
                  <label>Notice Weeks Given</label>
                  <input class="form-control" type="text" v-model="state.NoticeGiven" :readonly="!canEdit" />
                </div>
                <div :class="{ 'form-group--error': $v.state.RefundFeesPercentage.$error }">
                  <label v-if="isInternationalSchool">Eligible Refundable School Fees (%) </label>
                  <label v-else>Eligible Refundable Deposit (%) </label>
                  <select class="form-control" v-model="state.RefundFeesPercentage" :disabled="!canEdit">
                    <option value="100">100%</option>
                    <option value="50">50%</option>
                    <option value="0">0%</option>
                  </select>
                  <div class="error requiredFieldsMsg" v-if="!$v.state.RefundFeesPercentage.required" style="margin-bottom: 10px">
                    <el-alert :title="getValidationMessageFromKey('RefundFeesPercentage')" type="error"></el-alert>
                  </div>
                </div>
                <div :class="{ 'form-group--error': $v.state.RefundFees.$error }">
                  <label>Refundable Amount ($)</label>
                  <input class="form-control" type="text" v-model="state.RefundFees" :readonly="!canEdit" />

                  <div class="error requiredFieldsMsg" v-if="!$v.state.RefundFees.required" style="margin-bottom: 10px">
                    <el-alert :title="getValidationMessageFromKey('RefundFees')" type="error"></el-alert>
                  </div>
                </div>

                <div>
                  <label>Form Type</label>
                  <select class="form-control" v-model="state.FormType" :disabled="!canEdit">
                    <option :value="item" v-for="item in withdrawalConst.formTypeOptions">{{ item }}</option>
                  </select>
                </div>

                <div v-if="enrolStatus === 'Pending'">
                  <label>Additional Remarks (PL)</label>
                  <textarea class="form-control" v-model="state.RemarksPL" :readonly="!canEdit"></textarea>
                </div>

                <div v-else>
                  <K2Row align="center" class="mb-1">
                    <label>Additional Remarks (PL)</label>

                    <el-button v-if="canEdit || plEdit" class="ml-auto" type="secondary" size="mini" v-on:click="saveWithdrawalForm(null, true)"
                      >Save
                    </el-button>
                  </K2Row>
                  <span v-if="state.RemarksPL" style="white-space: pre-wrap">{{ state.RemarksPL }}</span>
                  <textarea class="form-control" v-model="state.tempRemarksPL" :readonly="!plEdit"></textarea>
                </div>

                <div>
                  <label>Additional Remarks (Principal)</label>
                  <textarea class="form-control" v-model="state.RemarksPrincipal" :readonly="!principalEdit"></textarea>
                </div>

                <div>
                  <label>Additional Remarks (Finance)</label>
                  <textarea class="form-control" v-model="state.RemarksFinance" :readonly="!financeEdit"></textarea>
                </div>
              </section>
              <WdfStaffSignature :approverList="approverList" />
              <section style="margin-bottom: 10px; display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 1rem">
                <K2Row class="mb-3">
                  <K2Checkbox
                    :item="{ label: 'Copy to Administration' }"
                    :state="state.CopyToAdmin"
                    @onchange="state.CopyToAdmin = $event"
                    :disabled="!canEdit"
                  ></K2Checkbox>
                </K2Row>
                <K2Row class="mb-3">
                  <K2Checkbox
                    :item="{ label: 'Copy to Bus Provider' }"
                    :state="state.CopyToBusProvider"
                    @onchange="state.CopyToBusProvider = $event"
                    :disabled="!canEdit"
                  ></K2Checkbox>
                </K2Row>
                <K2Row class="mb-3">
                  <K2Checkbox
                    :item="{ label: 'Update ICA (STP Holder)' }"
                    :state="state.UpdateToICA"
                    @onchange="state.UpdateToICA = $event"
                    :disabled="!canEdit"
                  ></K2Checkbox>
                </K2Row>
                <K2Row class="mb-3">
                  <K2Checkbox
                    :item="{ label: isInternationalSchool ? 'Update Class List/ Bus List' : 'Update CMS / Class List/ Bus List' }"
                    :state="state.UpdateClassList"
                    @onchange="state.UpdateClassList = $event"
                    :disabled="!canEdit"
                  ></K2Checkbox>
                </K2Row>
                <K2Row class="mb-3">
                  <K2Checkbox
                    :item="{ label: 'Inform Class Teacher' }"
                    :state="state.InformClassTeacher"
                    @onchange="state.InformClassTeacher = $event"
                    :disabled="!canEdit"
                  ></K2Checkbox>
                </K2Row>
              </section>
            </div>
          </div>
          <div class="enrol-manage-button-container" style="margin: 20px 0">
            <div v-if="listCount >= 0 || isLoading" style="display: flex">
              <el-button-group v-if="canEdit">
                <el-button type="primary" v-on:click="validationForm(true)"> Submit </el-button>
              </el-button-group>
              <el-button-group v-if="principalEdit || financeEdit">
                <el-button type="danger" v-on:click="rejectClick()">Reject </el-button>
              </el-button-group>
              <el-button v-if="principalEdit" class="ml-auto" type="primary" v-on:click="approveClick()"> Approved </el-button>
              <el-button v-if="financeEdit" class="ml-auto" type="primary" v-on:click="approveClick()"> Verify </el-button>

              <el-button v-if="enrolStatus === 'Pending'" type="warning" v-on:click="deleteClick()">Delete</el-button>

              <el-button v-if="(canEdit || plEdit) && enrolStatus === 'Pending'" class="ml-auto" type="secondary" v-on:click="validationForm()"
                >Save
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import DataSource from '../../data/datasource'
import { lang } from '../../locale/index'
import WdfStudentPassInformation from './text/WdfStudentPassInformation'
import WdfStudentInformation from './text/WdfStudentInformation'
import StudentWithdrawForm from '../../components/StudentWithdrawForm'
import ApfBasicInput from '../application/components/ApfBasicInput'
import { getValidationMessageFromKey, ehValidationsOfficial } from './component/data.js'
import WdfStaffSignature from './text/WdfStaffSignature'
import K2Checkbox from '../../uiComponents/k2Checkbox/k2Checkbox'
import K2Row from '../../uiComponents/k2Row/k2Row'
import { getFormatDate } from '@/helper/utily'
import { getUserGroup, isInternational } from '@/helper/util_custom'
import K2Button from '../../uiComponents/k2Button/k2Button'
import assets from '../../assets/assets'
import K2Upload from '../../uiComponents/k2Input/K2Upload'
import { WithdrawReason } from './component/withdrawReason'
import OnlineStudentWithdrawForm from './component/onlineStudentWithdrawalForm.vue'
import WithdrawalFormLogo from '@/pages/withdrawal/component/withdrawLogo.vue'
import withdrawalConst from '@/pages/withdrawal/withdrawalConst'

export default {
  validations: ehValidationsOfficial,
  name: 'withdrawalManagement',
  components: {
    WithdrawalFormLogo,
    OnlineStudentWithdrawForm,
    K2Upload,
    K2Button,
    K2Row,
    K2Checkbox,
    WdfStaffSignature,
    ApfBasicInput,
    StudentWithdrawForm,
    WdfStudentInformation,
    WdfStudentPassInformation,
  },
  data() {
    return {
      isLoading: false,
      assets: assets,
      date: '',
      mainReason: '',
      school: '',
      schoolText: '',
      isSubmitted: false,
      isDraft: false,
      studID: '',
      studPassHolder: '',
      accountHolderName: '',
      bankName: '',
      swiftCode: '',
      accountNo: '',
      email: '',
      contact: '',
      parentName: '',
      siSignature: '',
      state: {
        RefundFeesPercentage: null,
        RefundFees: null,
        ExceptionRequestDocs: [],
        ExceptionRequest: null,
        Reason1: null,
        Reason1Text: null,
        Improvement: null,
        // Reason2Text: null,
        // Reason3Text: null,
        isNotice: null,
        School: null,
        CountryName: null,
        FormType: 'Withdrawal',
      },
      authUserEmail: Cookies.get('userEmailSession'),
      apiHost: process.env.VUE_APP_ROOT_API,
      listCount: '',
      userGroup: null,
      isInternationalSchool: '',
      approverList: [],
      withdrawalFormID: '',
      currentSchool: '',
      enrolStatus: null,
      withdrawReasonList: WithdrawReason,
      withdrawalConst,
    }
  },
  async mounted() {
    window.V = this
    this.schoolList = (await DataSource.shared.getSchoolDropdownList('UTY201300000061'))?.Table
    await this.initFetch()
    this.userGroup = await getUserGroup()
  },
  watch: {
    'state.isNotice': function (isNotice) {
      if (isNotice === 'yes') this.state.NoticeGiven = ''
    },
  },
  methods: {
    lang,
    async initFetch() {
      if (this.$route.query.id) {
        this.withdrawalFormID = this.$route.query.id
        await this.getWithdrawalDetail()
      }
    },
    getValidationMessageFromKey,
    handleInputChange(name, val) {
      this.$set(this.state, name, val)
    },
    async saveSignature(data) {
      this.signatureType = 'si'
      this.siSignature = data
      this.daSignature = data
    },

    async copySignaturenName() {
      this.daSignatureName = this.siSignatureName
    },
    async sendNotification() {
      const resp = await DataSource.shared.sendWithdrawalFormNotifications(this.$route.query.id)
      if (resp) {
        if (resp?.code === '1') {
          this.$notify({
            title: 'Notification',
            message: 'Notification sent',
          })
        }
      }
    },
    async getWithdrawalDetail() {
      try {
        this.state.ID = this.withdrawalFormID
        const resp = await DataSource.shared.getWithdrawalFormDetail(this.withdrawalFormID)
        this.listCount = resp.Form.length
        if (resp) {
          if (resp.code === '99') {
          } else {
            this.approverList = resp.Approvals
            this.state.Full_Name = resp?.Full_Name
            this.state.CLS_ClassName = resp?.CLS_ClassName
            this.state.CRS_Level = resp?.CRS_Level

            this.enrolBindingList = resp.Form
            this.enrolBindingList.forEach(m => {
              this.enrolStatus = m.Status
              this.state.StudentPass = m.StudentPass
              this.state.BankAccount = m.BankAccount
              this.state.BankAccountHolder = m.BankAccountHolder
              this.state.BankCode = m.BankCode
              this.state.BankName = m.BankName
              this.state.Contact = m.Contact
              this.state.StudentName = m.StudentName
              this.state.Email = m.Email
              this.state.ParentName = m.ParentName
              this.state.ParentSignature = m.ParentSignature
              this.state.Date = m.Date
              this.state.MainReason = m.MainReason
              this.state.Reason1 = m.Reason1
              this.state.FormType = m.FormType
              this.state.Reason1Text = m.Reason1Details
              this.state.School = m.School
              this.state.schoolText = m.SchoolDetails
              this.state.SchoolType = m.SchoolType
              this.state.CountryName = m.CountryName
              this.state.Improvement = m.Improvement
              this.state.RemarksPL = m.RemarksPL
              this.state.RemarksPrincipal = m.RemarksPrincipal
              this.state.RemarksFinance = m.RemarksFinance
              this.state.CopyToAdmin = m?.CopyToAdmin === 'true' && true
              this.state.CopyToParents = m?.CopyToParents === 'true' && true
              this.state.CopyToBusProvider = m?.CopyToBusProvider === 'true' && true
              this.state.UpdateToICA = m?.UpdateToICA === 'true' && true
              this.state.UpdateClassList = m?.UpdateClassList === 'true' && true
              this.state.InformClassTeacher = m?.InformClassTeacher === 'true' && true
              this.state.ExceptionRequest = m?.ExceptionRequest
              this.state.DateOfNotice = m?.CreatedAt && getFormatDate(m?.CreatedAt)
              if (m?.ExceptionRequestDocs) {
                this.state.ExceptionRequestDocs = JSON.parse(m?.ExceptionRequestDocs)
              }
              if (m.NoticeGiven) {
                this.state.isNotice = 'no'
              } else {
                this.state.isNotice = 'yes'
              }
              this.state.NoticeGiven = m.NoticeGiven
              this.state.RefundFeesPercentage = m.RefundFeesPercentage
              this.state.RefundFees = m.RefundFees
              this.currentSchool = this.schoolList?.find(d => d.SchoolID === m?.CurrentSchool)
              this.isInternationalSchool = isInternational(this.currentSchool?.SchoolName)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async validationForm(isSubmit) {
      this.$v.$touch()
      if (this.$v.$error) {
        return this.flashError('Please fill in all * fields')
      }
      window.scrollTo(0, 0)
      if (isSubmit) {
        await this.approveClick(true)
      } else {
        await this.saveWithdrawalForm()
      }
    },
    flashError(msg) {
      return this.$notify.error({ title: 'Error', message: msg })
    },
    async approveClick(isSubmit) {
      this.$vs.loading()
      window.scrollTo(0, 0)
      this.isLoading = true

      await this.saveWithdrawalForm('approve')
      try {
        const resp = await DataSource.shared.approveWithdrawalForm(this.withdrawalFormID)
        if (resp) {
          if (resp.code === '99') {
            this.$notify.error({
              title: 'Error 99',
              type: 'Error 99',
              message: resp.message || 'Error 99!',
            })
          } else if (resp.code === '2') {
          } else if (resp.code === '3') {
            this.$notify.error({
              title: (isSubmit ? 'Submit' : 'Approve') + ' Failed',
              message: 'Status not valid!',
              type: 'approve',
            })
          } else if (resp.code === '1') {
            this.$router.push('WithdrawalList')

            //todo Approved. refresh the page
            this.$notify.success({
              title: 'Success',
              message: isSubmit ? 'Submitted!' : 'Approved!',
              type: 'success',
              duration: 2000,
            })
            // await this.getWithdrawalDetail();

            if (resp.code !== '1') {
              this.isLoading = false
            }
            // setTimeout(() => this.$router.push("WithdrawalList"), 3000);
          }
        }
      } catch (e) {
        console.log(e, 'approveClick err')
      }
    },
    async rejectClick() {
      this.$vs.loading()
      window.scrollTo(0, 0)
      this.isLoading = true
      try {
        await this.saveWithdrawalForm('approve')
        const resp = await DataSource.shared.rejectWithdrawalForm(this.withdrawalFormID)

        if (resp) {
          if (resp.code === '99') {
            this.$notify.error({
              title: 'Error 99',
              message: 'Error 99!',
              type: 'Error 99',
            })
          } else if (resp.code === '2') {
          } else if (resp.code === '3') {
            this.$notify.error({
              title: 'Reject Failed',
              message: 'Status not valid!',
              type: 'reject',
            })
          } else if (resp.code === '1') {
            this.$router.push('WithdrawalList')

            //todo Approved. refresh the page
            this.$notify.success({
              title: 'Success',
              message: 'Rejected!',
              type: 'success',
              duration: 2000,
            })
            // await this.getWithdrawalDetail();

            // setTimeout(() => this.$router.push("WithdrawalList"), 3000);
          }
          if (resp.code !== '1') {
            this.isLoading = false
          }
        }
      } catch (e) {
        console.log(e, 'rejectClick err')
      }
    },
    async deleteClick() {
      this.$vs.loading()
      const resp = await DataSource.shared.deleteWithdrawalForm(this.$route.query.id)
      if (resp) {
        if (resp.code === '99') {
          this.$notify.error({
            title: 'Error 99',
            message: 'Error 99!',
            type: 'Error 99',
          })
        } else if (resp.code === '2') {
        } else if (resp.code === '3') {
          this.$notify.error({
            title: 'Delete Failed',
            message: 'Status not valid!',
            type: 'reject',
          })
        } else if (resp.code === '1') {
          //todo Approved. refresh the page
          this.$notify.success({
            title: 'Success',
            message: 'Deleted!',
            type: 'success',
            duration: 2000,
          })
          this.$router.push('WithdrawalList')
        }
      }
    },
    setExceptionRequestDocs(files) {
      let fileList = this.state.ExceptionRequestDocs

      fileList.push(files)
      this.state.ExceptionRequestDocs = fileList
    },
    async saveWithdrawalForm(isApprove, isPLEdit) {
      await this.$vs.loading()
      try {
        const res = await DataSource.shared.saveWithdrawalForm(this.state)
        if (res) {
          const code = Number(res?.code || 0)
          if (code !== 1) {
            this.flashError(res?.message || 'Unknown Error! Please contact support.')
          } else {
            this.$notify({
              title: 'Success',
              message: 'Records Successfully Saved',
              type: 'success',
            })
            this.isSubmitted = true
            if (isPLEdit) {
              await this.getWithdrawalDetail(this.$route.query.id)
              this.state.tempRemarksPL = ''
            }
            if (!isApprove && !isPLEdit) {
              // window.location.reload();
              this.initFetch()
            }
          }
        }
      } finally {
        this.$vs.loading.close()
      }
    },
    handleSelectionChange() {},

    isImage(APAT_EnrolFileExt) {
      let ext = String(APAT_EnrolFileExt).toUpperCase()
      let isImage = false

      switch (ext) {
        case '.PNG':
        case '.JPG':
        case '.BMP':
        case '.GIF':
        case '.JPEG':
          isImage = true
          break
        default:
          isImage = false
          break
      }

      return isImage
    },

    getSource(file) {
      if (file.APAT_EnrolFileName === 'ParentSignature') {
        return file.APAT_OriginalFileString
      } else {
        if (this.isImage(file.APAT_EnrolFileExt)) {
          return 'data:' + file.APAT_FileType + ';base64,' + file.APAT_OriginalFileString
        } else if (file.APAT_EnrolFileExt.toLowerCase() === '.pdf') {
          return 'data:' + file.APAT_FileType + ';base64,' + file.APAT_OriginalFileString
        } else {
          return ''
        }
      }
    },
  },
  computed: {
    validationErrors() {
      return Object.entries(this.$v).filter(([key, attr]) => attr?.$anyError)
    },
    canEdit: function () {
      return this.userGroup?.find(d => d.GRPname === 'PLO') && this.enrolStatus === 'Pending'
    },
    plEdit: function () {
      return this.userGroup?.find(d => d.GRPname === 'PLO') && this.enrolStatus !== 'Pending'
    },
    principalEdit: function () {
      return this.userGroup?.find(d => d.GRPname === 'Principal') && this.enrolStatus === 'Submitted'
    },
    financeEdit: function () {
      return this.userGroup?.find(d => d.GRPname === 'Finance') && this.enrolStatus === 'Approved'
    },
    enableWithdrawalDate: function () {
      return this.userGroup?.find(d => d.GRPname === 'PLO') && this.enrolStatus === 'Pending'
    },
  },
}
</script>

<style scoped>
h5 {
  text-align: center;
  background-color: rgb(43, 0, 128);
  border-radius: 5px;
  color: white;
  margin: 0px 10px 10px 0px;
}

.time-line-box .status span {
  padding-top: 8px;
}

.time-line-box .status span:before {
  content: '';
  width: 10px;
  height: 10px;
  background-color: #ff4242;
  border-radius: 12px;
  border: 2px solid #426dff;
  position: absolute;
  left: 50%;
  top: 0%;
  transform: translate(-50%, -50%);
  transition: all 200ms ease-in;
}

.time-line-box .statusYetDone span:before {
  content: '';
  width: 12px;
  height: 12px;
  background-color: #d3d9e8;
  border-radius: 12px;
  border: 2px solid #d3d9e8;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, -50%);
  transition: all 200ms ease-in;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

ul li {
  margin: 0;
  padding: 0;
}

h5 {
  font-size: 1.1rem;
}

.div-profile img {
  height: 180px;
  width: 180px;
  border-radius: 50%;
  object-fit: scale-down;
}

.enrolment-manage-container {
  background: #ffffff;
  border-radius: 6px;
  min-height: 100vh;
  width: 73%;
  margin-left: auto;
  padding: 20px;
}

.common-row-div-margin {
  margin: 0;
}
</style>
